import React, { useState } from "react";
import { Button, Divider, Modal } from "antd";
import { MainText, SubText } from "../../../../helpers/StyledComponents";

const TITLE = "WHAT WE BELIEVE";
const BelievesModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        style={{ width: "200px" }}
      >
        <div>{TITLE}</div>
      </Button>
      <Modal
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={null}
      >
        <MainText align="center">{TITLE}</MainText>
        <Divider />
        <SubText>
          The Scripture Union family throughout the world, we accept and
          proclaim the historic truths of the Christian faith, including the
          following:
        </SubText>
        <ul>
          <li>God and the human race</li>
          <li>The Scriptures</li>
          <li>The Church and its mission</li>
        </ul>
        <MainText mt="40" align="center">
          GOD AND THE HUMAN RACE
        </MainText>
        <Divider />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <SubText>
            <strong>We hold that that the Lord our God is one:</strong> Father,
            Son and Holy Spirit, and that he fulfils his sovereign purposes - in
            creation, revelation, redemption, judgement, and the coming of his
            kingdom - by calling out from the world a people united to himself
            and to each other in love.
          </SubText>
          <SubText>
            <strong>We acknowledge that though God made us</strong> in his own
            likeness and image, conferring on us dignity and worth and enabling
            us to respond to himself, we now are members of a fallen race; we
            have sinned and come short of his glory.
          </SubText>
          <SubText>
            <strong>We believe that the Father</strong> has shown us his holy
            love in giving Jesus Christ, his only Son, for us, while through our
            sinfulness and guilt, we were subject to his wrath and condemnation;
            and has shown his grace by putting sinners right with himself when
            they place their trust in his Son.
          </SubText>
          <SubText>
            <strong>We confess Jesus Christ</strong> as Lord and God; as truly
            human, born of the virgin Mary; as Servant, sinless, full of grace
            and truth; as only Mediator and Saviour, dying on the cross in our
            place, representing us to God, redeeming us from the grip, guilt and
            punishment of sin; as Victor over Satan and all his forces, rising
            from death with a glorious body, being taken up to be with his
            Father, one day returning personally in glory and judgement to
            establish his kingdom.
          </SubText>
          <SubText>
            <strong>We believe in the Holy Spirit</strong> who convicts the
            world of guilt in regard to sin, righteousness and judgement; who
            makes the death of Christ effective to sinners, declaring that they
            must now turn to Christ in repentance, and directing their trust
            towards the Lord Jesus Christ; who through the new birth makes us
            partake in the life of the risen Christ, and who is present within
            all believers, illuminating their minds to grasp the truth of
            Scripture, producing in them his fruit, granting to them his gifts,
            and empowering them for service in the world.
          </SubText>
        </div>
        <MainText mt="40" align="center">
          THE SCRIPTURES
        </MainText>
        <Divider />
        <SubText indent>
          We believe that the Old and New Testament Scriptures are God-breathed,
          since their writers spoke from God as they were moved by the Holy
          Spirit; hence are fully trustworthy in all that they affirm; and are
          our highest authority for faith and life.
        </SubText>
        <MainText mt="40" align="center">
          THE CHURCH AND ITS MISSION
        </MainText>
        <Divider />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <SubText>
            <strong>We recognise the Church</strong> as the body of Christ held
            together and growing up in him; both as a total fellowship
            throughout the world, and as the local congregation in which
            believers gather.
          </SubText>
          <SubText>
            <strong>We acknowledge the commission of Christ</strong> to proclaim
            the Good News to all people, making them disciples, and teaching
            them to obey him and
          </SubText>
          <SubText>
            <strong>We acknowledge the command of Christto</strong> love our
            neighbours, resulting in service to the church and society, in
            seeking reconciliation for all with God and their fellows, in
            proclaiming liberty from every kind of oppression; and in spreading
            Christ's justice in an unjust world, until he comes again.
          </SubText>
        </div>
      </Modal>
    </>
  );
};

export default BelievesModal;
